<ap-table #table [(originalData)]="data" [(data)]="tableData" class="app-table" [styleClass]="'custom-table'"
  [condensed]="false">
  <table>
    <thead>
      <tr>
        @for (column of columns; track column) {
          <th ap-sort [sortKey]="column.key">
            <span>{{column.value}}</span>
            @if (column.type == 'avatar' && column.editable && id) {
              <app-user-form-modal [objectType]="'User'" [modalId]="id" (onSubmitEvent)="onUserSubmit($event)"></app-user-form-modal>
            }
          </th>
        }
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (data of tableData; track trackId(i, data); let i = $index) {
        <tr>
          @for (c of columns; track c) {
            <td>
              @switch (c.type) {
                @case ('avatar') {
                  <div class="d-flex align-items-center">
                    <div class="avatar-wrapper">
                      <img [src]="getHeadshot(data.headshot)"
                        alt="avatar" [width]="avatarDiameter" [height]="avatarDiameter">
                      @if (c.editable) {
                        <div class="avatar-backdrop">
                          <i class="Appkit4-icon icon-edit-outline" (click)="showUserModal(data)"></i>
                        </div>
                      }
                    </div>
                    <span>{{data.firstName + ' ' + data.lastName}}</span>
                    @if (data.notes) {
                      <span class="Appkit4-icon icon-information-outline ap-ml-spacing-2"
                        ap-tooltip [tooltipId]="'tooltipDesc'" ariaDescribedby="tooltipDesc"
                      [tooltipContent]="data.notes" [direction]="'top'"></span>
                    }
                  </div>
                }
                @case ('text') {
                  @if (c.editable) {
                    <input #input class="custom_input" type="text" [value]="data[c.key] || ''"
                      [placeholder]="c.placeholder || ''" (focusout)="onTableChange(input.value, c.key, i)" />
                  }
                  @if (!c.editable) {
                    <div>{{data[c.key]}}</div>
                  }
                }
                @case ('roleDropdown') {
                  <app-role-list [placeholder]="c.placeholder!" [(ngModel)]="data[c.key]" (onChangeEvent)="onTableChange($event, c.key, i)" ></app-role-list>
                }
                @case ('timepicker') {
                  <ap-timepicker hourTitle="HH" minuteTitle="MM"
                    [styleClass]="'custom-timepicker'" [hideTitleOnInput]="true" [inline]="false" [hourTime]="12"
                    [(ngModel)]="data[c.key]" (onValueChange)="onTableChange($event, c.key, i)">
                  </ap-timepicker>
                }
              }
            </td>
          }
          <td>
            <ap-button [type]="'button'" [btnType]="'text'" [icon]="'delete-outline'"
            (onClick)="delete(i)"></ap-button>
          </td>
        </tr>
      }
    </tbody>
    @if (type == 'inline') {
      <tfoot [formGroup]="inlineForm">
        <tr>
          @for (c of columns; track c; let i = $index) {
            <td>
              @switch (c.type) {
                @case ('text') {
                  <div>
                    <input #input class="custom_input" type="text" [placeholder]="c.placeholder" [formControlName]="c.key"/>
                  </div>
                }
                @case ('timepicker') {
                  <ap-timepicker hourTitle="HH" minuteTitle="MM" [styleClass]="'custom-timepicker'" [hideTitleOnInput]="true"
                    [inline]="false" [hourTime]="12" [formControlName]="c.key">
                  </ap-timepicker>
                }
              }
            </td>
          }
          <td>
            <ap-button type="button" class="d-flex" [label]="'Add'" (onClick)="add(inlineForm.value)" [disabled]="!inlineForm.valid"></ap-button>
          </td>
        </tr>
      </tfoot>
    }
  </table>
</ap-table>
@if (type == 'search') {
  <div class="search">
    <app-search-field (onSearchEvent)="onSearch($event)" [searchService]="searchService" (onCreateEvent)="showUserModal($event)"></app-search-field>
  </div>
}
